import { ProcessedScanResult } from "../../components/Pages/Diary/SpaceScanner/SpaceScanner.types";
import { LOCKED_OR_EXCLUDED_RESULT_TYPES } from "../../components/Pages/Diary/SpaceScanner/SpaceScannerConstants";
import { ScanDecision } from "./types/ScanHistory.types";

export const buildDecisionsFromResults = (
  results: ProcessedScanResult[],
  venueId: string,
  scanSessionId: string
): ScanDecision[] => {
  const now = Date.now();

  return results
    .filter((r) => !LOCKED_OR_EXCLUDED_RESULT_TYPES.includes(r.result))
    .map((result) => {
      const booking = result.booking as typeof result.booking & {
        labels?: string[];
      };

      return {
        venueId,
        scanSessionId,
        timestamp: now,
        bookingId: booking._id,
        bookingType: result.booking.type?.name ?? "Unknown",
        partySize: result.booking.num_people,
        fromAreaId: result.previousAreas?.[0]?.id ?? "",
        fromAreaName: result.previousAreas?.[0]?.name ?? "Unassigned",
        toAreaId: result.newAreas?.[0]?.id ?? "",
        toAreaName: result.newAreas?.[0]?.name ?? "Unassigned",
        accepted: result.moved,
        resultType: result.result,
        labels: booking.labels ?? [],
        timeSlot: result.booking.time ?? "",
        scanApplied: false
      };
    });
};
